/*
 * 作者: Fultom
 * 创建时间: 2021-03-02 15:59:00
 * 最近修改时间: 2024-01-09 16:40:16
 * 功能:
 */


// 安卓/IOS/小程序 对接H5 方法
export function externalCallFunc({
  funcName,
  params,
  wx_path,
  default_func
}) {
  let origin = sessionStorage.getItem('origin');
  if (!origin) {
    origin = localStorage.getItem("origin");
  }

  console.log("call native:", funcName, params)
  if (origin === 'ios') { // ios
    if (window.webkit.messageHandlers) {
      window.webkit.messageHandlers[funcName].postMessage(params);
    } else {
      setTimeout(function () {
        if (window.webkit.messageHandlers) {
          window.webkit.messageHandlers[funcName].postMessage(params);
        }
      }, 2000);
    }
  } else if (origin === 'android') { // android
    if (window.android) {
      // 通过JSON.stringify方法将params对象转化成json字符串传递给安卓
      params ? window.android[funcName](JSON.stringify(params)) : window.android[funcName]()
    }

  } else if (origin === 'wechat' && wx_path) { // wechat
    wx.miniProgram.navigateTo({
      url: wx_path
    })
  } else {
    if (default_func) {
      default_func()
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/webviewUtils.js